/**
 * Extracts bare numeric IDs from a targeting val string/array.
 * Values already in "id:name" format are skipped (they don't need resolution).
 * Shared between oa-ui (GraphQL `optionsByPath`) and unity/REST apps (REST `/appgroup`).
 */
export const extractBareIds = (val: string | string[] | undefined): string[] => {
  if (!val) return [];
  const values = typeof val === 'string' ? val.split(',') : val;
  const bareIds: string[] = [];
  for (const value of values) {
    const trimmed = value.trim();
    if (trimmed !== '' && !trimmed.includes(':')) {
      bareIds.push(trimmed);
    }
  }
  return bareIds;
};
